import React, {Component} from 'react';
import {NavBar,TextareaItem,Modal,Toast} from "antd-mobile";
import { suggestion } from "../../../service/memberService";
import {connect} from "react-redux"; 
import "./style.less";

@connect(
    state => ({userInfo: state.userInfo})
)

export default class Suggestion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    componentDidMount() {

    }
  
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    Submit = () => {
        if (this.state.value == '') {
            Toast.info('输点什么再提交吧', 2);
        } else {
            Toast.loading("",0);
            let params = {
                token: this.props.userInfo.token,
                source:1,
                data:{source:1,content:this.state.value,}
            };
            suggestion(params).then((res) => {
                    if (res.data.code === '0000') {
                        Toast.info('提交成功！感谢小主宝贵的意见！我们会继续努力哒',3,()=>this.props.history.goBack());
                    } else {
                        Toast.info(res.data.msg);
                    }
                }).catch(function (error) {
                console.log(error);
            });
        }
    };

    render() {
        return (
            <div className="suggestion">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >意见反馈</NavBar>

                <div className="warp">
                    <TextareaItem
                        rows={5}
                        value={this.state.value}
                        placeholder="请输入您的宝贵意见"
                        onChange={v => this.inputChange(v, 'value')}
                        autoHeight="autoHeight "
                    />
                    <button onClick={this.Submit}>提 交</button>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Suggestion/index.js